module.exports = __webpack_public_path__ + "img/archive.e5fced8f.png";